import { timeModes } from "../../../constant";

export const TimeModeSelector = ({ selectedMode, onChange, disabled }) => {
  return (
    <div className="inline-flex rounded group md:h-6 h-4 md:w-44 w-36 border-black border">
      {timeModes.map((tm) => (
        <button
          type="button"
          className={` md:text-xs text-xxs font-medium text-center w-1/3 px-1 ${
            tm.id === timeModes[0].id
              ? "rounded-tl rounded-bl"
              : tm.id === timeModes[timeModes.length - 1].id
              ? "rounded-tr rounded-br border-l border-black"
              : "border-l border-black"
          }  ${
            selectedMode === tm.id
              ? "bg-black text-white"
              : "text-black bg-white"
          }`}
          onClick={() => onChange(tm.id)}
          disabled={disabled}
          key={tm.id}
        >
          {tm.name}
        </button>
      ))}
    </div>
  );
};
